import { DOCTOR } from "@/lib/data";

export default function About() {
  return (
    <section id="about" data-testid="about-section" className="section">
      <div className="container-page grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center">
        <div className="lg:col-span-5">
          <div className="relative aspect-[4/5] rounded-[40px] overflow-hidden border border-sand">
            <img
              src="https://images.unsplash.com/photo-1773997653557-11668a338301"
              alt="Soft botanical detail"
              className="w-full h-full object-cover transition-transform duration-700 hover:scale-105"
            />
          </div>
        </div>

        <div className="lg:col-span-7">
          <p className="label-eyebrow">About the Doctor</p>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl tracking-tight text-forest mt-5 leading-[1.05]">
            A trusted hand through
            <span className="italic text-terracotta"> every chapter</span> of womanhood.
          </h2>
          <p className="mt-8 text-lg leading-relaxed text-forest/75">
            {DOCTOR.name} is a Consultant Gynaecologist & Obstetrician serving the women of Birpara and Alipurduar with quiet expertise and genuine warmth. Her practice spans the full arc of women's health — from adolescence and fertility to childbirth, recovery, and the wisdom years.
          </p>
          <p className="mt-5 text-lg leading-relaxed text-forest/75">
            Trained at Medical College, Kolkata, with a D.N.B. in Obstetrics & Gynaecology, she brings rigorous medical care delivered with patience, privacy, and respect for every woman who walks through the door.
          </p>

          <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-6">
            <div className="card-soft p-6">
              <p className="label-eyebrow">Qualifications</p>
              <p className="font-serif text-2xl mt-3 text-forest leading-snug">MBBS (Hons)</p>
              <p className="text-forest/70">D.G.O. — Medical College, Kolkata</p>
              <p className="text-forest/70">D.N.B. — Obstetrics & Gynaecology</p>
            </div>
            <div className="card-soft p-6">
              <p className="label-eyebrow">Languages</p>
              <ul className="mt-3 font-serif text-2xl text-forest space-y-0.5">
                {DOCTOR.languages.map((lang) => (
                  <li key={lang} data-testid={`lang-${lang.toLowerCase()}`}>{lang}</li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
